module.exports = __webpack_public_path__ + "assets/af51584cac2825620e43d288aa225b01.png";